/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_HighInputs */

const en_us2_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High risk`)
};

const pt_br2_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risco alto`)
};

const es_419_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riesgo alto`)
};

const pt_pt2_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risco elevado`)
};

const fr_fr2_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risque élevé`)
};

const de_de2_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hohes Risiko`)
};

const it_it2_body_assessment_whtr_band_high = /** @type {(inputs: Body_Assessment_Whtr_Band_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rischio alto`)
};

/**
* | output |
* | --- |
* | "High risk" |
*
* @param {Body_Assessment_Whtr_Band_HighInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_high = /** @type {((inputs?: Body_Assessment_Whtr_Band_HighInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_HighInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_high(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_high(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_high(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_high(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_high(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_high(inputs)
	return en_us2_body_assessment_whtr_band_high(inputs)
});
export { body_assessment_whtr_band_high as "body-assessment.whtr_band.high" }